import React from 'react';
import './Shoes.css';
import ProductCard from './ProductCard';

function Shoes() {
  const templates = [
    { name: 'Kente Beaded Sandals', price: 65, image: '👞', imageUrl: '/ankara shoes.jfif', description: 'Beautiful beaded sandals with Kente patterns' },
    { name: 'Ankara Print Heels', price: 75, image: '👠', imageUrl: '/ankara shoes.jfif', description: 'Stylish heels with authentic Ankara prints' },
    { name: 'Traditional African Slides', price: 55, image: '👞', imageUrl: '/ankara shoes.jfif', description: 'Comfortable slides with traditional patterns' },
    { name: 'Gold Embroidered Flats', price: 70, image: '👡', imageUrl: '/ankara shoes.jfif', description: 'Elegant flats with gold embroidery' },
    { name: 'Leather Tribal Boots', price: 95, image: '👢', imageUrl: '/ankara shoes.jfif', description: 'Premium leather boots with tribal designs' },
    { name: 'Wax Print Sneakers', price: 80, image: '👟', imageUrl: '/ankara shoes.jfif', description: 'Comfortable sneakers with wax print design' },
  ];

  const shoes = Array.from({ length: 20 }, (_, index) => {
    const template = templates[index % templates.length];
    return {
      id: index + 1,
      name: `${template.name} ${index + 1}`,
      price: template.price + (index % 4) * 5,
      image: template.image,
      imageUrl: template.imageUrl,
      description: `${template.description} • ${['Signature', 'Heritage', 'Modern', 'Festival'][index % 4]}`,
    };
  });

  return (
    <div className="shoes-section">
      <div className="section-header">
        <div>
          <p className="section-eyebrow">Modern African Footwear</p>
          <h2>African Shoes & Footwear</h2>
          <p>Comfortable, stylish and proudly rooted in heritage.</p>
        </div>
        <div className="section-badges">
          <span>20 curated pairs</span>
          <span>Premium finish</span>
          <span>Ready to wear</span>
        </div>
      </div>
      <div className="products-grid">
        {shoes.map((shoe) => (
          <ProductCard key={shoe.id} product={shoe} />
        ))}
      </div>
    </div>
  );
}

export default Shoes;
